import { createGlobalStyle } from 'styled-components';

export const mainTheme = {
    name: 'Main Theme',
    colors: {
        white: '#fff',
        grey: 'rgba(255, 255, 255, 0.6)',
        darkGrey: 'rgba(255, 255, 255, 0.1)',
        black: '#020202',
        blue: '#1400e7',
        green: '#54b435',
    },
    breakpoints: {
        xs: 390,
        sm: 768,
        md: 992,
        lg: 1200,
        xl: 1400,
    },
};

const GlobalStyle = createGlobalStyle`
    *,
    *:after,
    *:before {
        box-sizing: border-box;
    }

    html {
        --webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        height: 100%;
    }

    body {
        font-size: 16px;
        line-height: 24px;
        font-family: 'Syne', sans-serif;
        background: #000;
        color: #fff;
        padding: 0;
        margin: 0;
        height: 100%;

        &.modal-open {
            overflow: hidden;
        }
    }

    a {
        text-decoration: none;
        color: ${mainTheme.colors.white};
        cursor: pointer;
        transition: color 0.2s ease;

        &:hover {
            color: ${mainTheme.colors.blue};
        }
    }

    img {
        max-width: 100%;
    }
`;

export default GlobalStyle;
